import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-amrita',
  templateUrl: './amrita.component.html',
  styleUrls: ['./amrita.component.scss']
})
export class AmritaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getAmrita();
  }
}
